var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.3 124.3H128.5V137.5H194.3V124.3Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.3 117.8C115.3 103.3 103.4 91.5 89 91.5C74.5 91.5 62.7 103.4 62.7 117.8C62.7 132.3 74.6 144.1 89 144.1C103.5 144.1 115.3 132.2 115.3 117.8ZM75.9 117.8C75.9 110.5 81.7 104.6 89.1 104.6C96.4 104.6 102.2 110.4 102.2 117.8C102.2 125.2 96.4 131 89.1 131C81.7 130.9 75.9 125.1 75.9 117.8Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 175.3L157.9 163C160 161.9 161.4 159.7 161.4 157.2C161.4 153.6 158.5 150.6 154.8 150.6C153.6 150.6 152.6 150.9 151.6 151.4L128.5 163.6L108.1 152.8C105.3 151.3 102.1 150.5 98.9 150.5H62.7V203.1H75.9V163.6H95.6V203.1H108.8V168L122.4 175.2C126.2 177.4 130.8 177.4 134.7 175.3Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.2 98H174.5V111.2H194.2V98Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.4 98H128.5V111.2H161.4V98Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.7 190.1C233.4 190.1 233.2 190.1 232.9 190.1H220.5V71.7H62.7C59.1 71.8 56.3 74.7 56.3 78.3C56.3 81.9 59.2 84.8 62.7 84.9H207.4V190.1H115.3V203.3H233.7V203.2C237.3 203.2 240.3 200.3 240.3 196.6C240.3 193 237.4 190.1 233.7 190.1Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.bb0ab357.svg";
export { ForwardRef as ReactComponent };